import { createFileRoute } from '@tanstack/react-router';
import { LearnArticleDetail } from '~/components/sections/LearnArticleDetail';
import { learnArticleHeadMeta, loadLearnArticle } from '~/lib/learn-article-route';

export const Route = createFileRoute('/bangladesh/$slug')({
  loader: ({ params }) => loadLearnArticle('bangladesh', params.slug),
  head: ({ loaderData }) => learnArticleHeadMeta(loaderData?.article),
  component: BangladeshArticlePage,
});

function BangladeshArticlePage() {
  const { article } = Route.useLoaderData();
  return <LearnArticleDetail key={article.fullPath} article={article} />;
}
